module.exports = new __parcel__URL__("no-results-dark.a00ae47b.svg").toString();